import { usePathname } from 'next/navigation';
import { useCallback } from 'react';
import usePrintUrlSearchParams from '@alltrails/maps/hooks/usePrintUrlSearchParams';

export function useRedirectToPrintUrl(isExploreTrail: boolean) {
  const pathname = usePathname();
  const getPrintUrlSearchParams = usePrintUrlSearchParams();

  return useCallback(() => {
    let printUrl: string;

    if (isExploreTrail) {
      const trailSlug = pathname.split('/trail/')[1];
      printUrl = `/trail/${trailSlug}/print?${getPrintUrlSearchParams().toString()}`;
    } else {
      printUrl = window.location.pathname
        .replace('/custom-routes/', '/map/')
        .replace(/\?.*$/, '')
        .concat(`/print?${getPrintUrlSearchParams().toString()}`);
    }

    window.location.assign(printUrl);
  }, [getPrintUrlSearchParams, isExploreTrail, pathname]);
}
